import axios from "axios";

const asaasGetPaymentInfos = async ({ paymentId, type }) => {
  try {
    const { data } = await axios.post(
      `/asaas/payment/infos`,
      {
        paymentId: paymentId,
        type: type,
      }
    );

    if (!data?.success) throw new Error();

    return {
      success: true,
      message: "Sucesso ao obter informações do pagamento",
      paymentImage: data?.paymentImage,
      paymentPayload: data?.paymentPayload,
    };
  } catch (error) {
    return {
      success: false,
      message: "Erro ao obter informações do pagamento",
    };
  }
};

export { asaasGetPaymentInfos };
